import { createSlice } from "@reduxjs/toolkit";

const token = localStorage.getItem("token");
const user = JSON.parse(localStorage.getItem("user"));

const authSlice = createSlice({
  name: "auth",
  initialState: {
    token: token || "",
    user: user || "",
  },
  reducers: {
    login(state, action) {
      state.token = action.payload;
    },
    logout(state) {
      state.token = "";
      state.user = "";
    },
    setUser(state, action) {
      state.user = action.payload;
    }
  },
});

export const { login, logout, setUser } = authSlice.actions;

export default authSlice.reducer;
